import Vue from 'vue'
import Router from 'vue-router'
import Layer1Index from '@/pages/layer1/index'
import FakeHome from '@/pages/layer1/fake-home'
import Home from '@/pages/layer1/home'
import LatestNav from '@/pages/layer2/books/latest-nav'
import RankedNav from '@/pages/layer2/books/ranked-nav'
import VipNav from '@/pages/layer2/books/vip-nav'
import Category from '@/pages/layer1/category'
import Shelf from '@/pages/layer1/shelf'
import New from '@/pages/layer1/new'
import User from '@/pages/layer1/user'
import Login from '@/pages/layer2/user/login'
// import Registration from '@/pages/layer2/user/registration'
import MobileBind from '@/pages/layer2/user/mobile-bind'
import ChangePassword from '@/pages/layer2/user/change-password'
import Purchase from '@/pages/layer2/user/purchase'
import PurchaseHistory from '@/pages/layer2/user/purchase-history'
import PurchaseList from '@/pages/layer2/user/purchase-list'
import PurchaseSuccess from '@/pages/layer2/user/purchase-success'

import Reaccount from '@/pages/layer2/user/re-account'
import BooksIndex from '@/pages/layer2/books/index'
import LatestList from '@/pages/layer2/books/latest'
import RecommendList from '@/pages/layer2/books/recommend'
import RankedList from '@/pages/layer2/books/ranked'
import BookIndex from '@/pages/layer2/book/index'
import BookHome from '@/pages/layer2/book/home'
import BookRead from '@/pages/layer2/book/read'
import Search from '@/pages/layer2/book/search'
// import BookContent from '@/components/layer2/book/read-content'
import BookCatalog from '@/pages/layer2/book/catalog'

Vue.use(Router)

Router.prototype.isBack = false

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
      name: 'index',
      component: Layer1Index,
      children: [
        {
          path: 'home',
          name: 'home',
          component: Home,
          meta: {
            type: 'none',
            number: 1,
            keepAlive: true
          }
        },
        {
          path: 'category',
          name: 'category',
          component: Category,
          meta: {
            type: 'none',
            number: 2,
            keepAlive: true
          }
        },
        {
          path: 'new',
          name: 'new',
          component: New,
          meta: {
            type: 'none',
            number: 3,
            keepAlive: true
          }
        },
        {
          path: 'shelf',
          name: 'shelf',
          component: Shelf,
          meta: {
            type: 'none',
            number: 4,
            keepAlive: true
          }
        },
        {
          path: 'user',
          name: 'user',
          component: User,
          meta: {
            type: 'none',
            number: 5,
            keepAlive: true
          }
        },
        {
          path: 'purchase',
          name: 'purchase',
          component: Purchase,
          meta: {
            type: 'horizontal',
            number: 6
          }
        }
      ]
    },
    {
      path: '/index',
      name: 'fake-home',
      component: FakeHome,
      meta: {
        type: 'none',
        number: 6
      }
    },
    // 添加后缀支持，使cdn能根据后缀缓存
    {
      path: '/home.html',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home-list-index',
      component: BooksIndex,
      children: [
        {
          path: 'recommend',
          name: 'home-recommend',
          component: RecommendList,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '小编推荐',
            keepAlive: true
          }
        },
        {
          path: 'ranked',
          name: 'home-ranked',
          component: RankedList,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '人气榜单',
            keepAlive: true
          }
        },
        {
          path: 'latest',
          name: 'home-latest',
          component: LatestList,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '最新上架',
            keepAlive: true
          }
        }
      ]
    },
    {
      path: '/books',
      name: 'books',
      component: BooksIndex,
      children: [
        {
          path: 'latest',
          name: 'latest',
          component: LatestNav,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '最近更新',
            keepAlive: true
          }
        },
        {
          path: 'ranked',
          name: 'ranked',
          component: RankedNav,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: '排行榜',
            keepAlive: true
          }
        },
        {
          path: 'vip',
          name: 'vip',
          component: VipNav,
          meta: {
            type: 'horizontal',
            number: 6,
            topTitle: 'VIP专区',
            keepAlive: true
          }
        }
      ]
    },
    {
      path: '/book',
      name: 'book',
      component: BookIndex,
      children: [
        {
          path: 'search',
          name: 'book-search',
          component: Search,
          meta: {
            type: 'horizontal',
            number: 1,
            topTitle: '最新上架',
            keepAlive: true
          }
        },
        {
          path: ':id',
          name: 'book-home',
          component: BookHome,
          meta: {
            type: 'vertical',
            number: 1,
            keepAlive: true
          }
        },
        {
          path: ':id/catalog',
          name: 'book-catalog',
          component: BookCatalog,
          meta: {
            type: 'vertical',
            number: 2,
            keepAlive: true
          }
        },
        {
          path: 'read/:id/:number',
          name: 'book-read',
          component: BookRead,
          meta: {
            type: 'vertical',
            number: 3
          }
        }
      ]
    },
    {
      path: '/user/login',
      name: 'user-login',
      component: Login,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/bind',
      name: 'user-bind',
      component: MobileBind,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/password',
      name: 'user-password',
      component: ChangePassword,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/purchase/history',
      name: 'user-purchase-history',
      component: PurchaseHistory,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/purchase/list',
      name: 'user-purchase-list',
      component: PurchaseList,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/purchase/success',
      name: 'user-purchase-success',
      component: PurchaseSuccess,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '/user/reaccount',
      name: 'user-reaccount',
      component: Reaccount,
      meta: {
        type: 'horizontal',
        number: 5
      }
    },
    {
      path: '*',
      name: 'other',
      redirect: '/'
    }
  ]
})
